import {createScriptIn} from './ui_utils/DomUtils.ts'
import {UIUtilsEjsVariables} from './UIUtilsEjsVariables.ts'
import {ClientUserState} from './ClientUserState.ts'

export class AdinPlayLoader {
    private static initialized = false
    static init() {
        if(this.initialized) return

        if(window.location.hostname === 'localhost') return
        if(UIUtilsEjsVariables.isUserOnDiscord) return
        if(UIUtilsEjsVariables.isUserOnMobile && UIUtilsEjsVariables.shouldHideAdsOnMobile) return
        if(UIUtilsEjsVariables.showVliAdAtBottomInGame) return
        if(ClientUserState.isStale()) return
        if(ClientUserState.userState?.items.hideAds()) return

        createScriptIn(document.body, '//api.adinplay.com/libs/aiptag/pub/KTN/colonist.io/tag.min.js')

        this.initialized = true
    }
}
